import { createContext, useContext } from 'react';

const noop = () => {};

const defaultNotifications = {
  success: noop,
  error: noop,
};

const ChatNotificationsContext = createContext(defaultNotifications);

/**
 * Optional toast-like API `{ success({ message }), error({ message }) }` (same shape as ann-web-app useToast).
 */
export function ChatNotificationsProvider({ value, children }) {
  return (
    <ChatNotificationsContext.Provider value={value ?? defaultNotifications}>
      {children}
    </ChatNotificationsContext.Provider>
  );
}

export function useChatNotifications() {
  return useContext(ChatNotificationsContext);
}
